import { Alert } from "antd";
import { getEmptyTabWarningMessage } from "../../utils/emptyTabWarning";

export default function EmptyTabWarning({ tabName }) {
  if (!tabName) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={getEmptyTabWarningMessage(tabName)}
      style={{ marginBottom: 16 }}
    />
  );
}
